import {
	Component,
	OnInit,
	Input,
	ComponentFactoryResolver,
	ViewContainerRef,
	ComponentRef,
	ViewChild,
	Output,
	EventEmitter,
	HostBinding,
	Optional,
	OnDestroy
} from "@angular/core";
import {
	CTAToggleButtonContext,
	CTAToggleButtonLayoutContext
} from "./cta-toggle-button.models";
import { CtaButtonLayoutIconTitleComponent } from "../../cta-button--layouts/cta-button-layout-icon-title/cta-button-layout-icon-title.component";
import { CtaButtonLayoutSubtitleNotePriceComponent } from "../../cta-button--layouts/cta-button-layout-subtitle-note-price/cta-button-layout-subtitle-note-price.component";
import { CTAButtonLayout } from "../../cta-button--layouts/cta-button-layout";
import { CtaToggleButtonGroupComponent } from "../cta-toggle-button-group/cta-toggle-button-group.component";
import { CtaButtonLayoutInternetDataComponent } from "@dodo/cta-buttons/cta-button--layouts/cta-button-layout-internet-data/cta-button-layout-internet-data.component";

const components = {
	IconTitleContext: CtaButtonLayoutIconTitleComponent,
	SubtitleNotePriceContext: CtaButtonLayoutSubtitleNotePriceComponent,
	TitleNotePriceContext: CtaButtonLayoutInternetDataComponent
};

@Component({
    selector: "dodo-cta-toggle-button",
    templateUrl: "./cta-toggle-button.component.html",
    styleUrls: ["./cta-toggle-button.component.scss"],
    standalone: false
})
export class CtaToggleButtonComponent implements OnInit, OnDestroy {
	@Input() id: string | number;
	@Input() layoutContext: CTAToggleButtonLayoutContext;
	@Input() isRadio: boolean;
	@Input() isCheckBox: boolean;
	@HostBinding("class.active")
	__active: boolean;

	__selected: boolean;

	@Input() set active(val: boolean) {
		console.log("activating button : ", this.id, val);
		this.__active = val;
	}

	@Input() set clearSelections(val: boolean) {
		// if (val) {
		// 	this._clicked(true);
		// }
	}

	@Input() set selected(val: boolean) {
		console.log("activating button : ", this.id, val);
		this.__selected = val;
		if (val) {
			this._clicked(false);
		}
	}

	@HostBinding("class.disabled")
	@Input()
	disabled: boolean;

	@Input()
	tags: string[];

	@Input()
	titleBelowButton: string;

	@Input()
	buttonBelowFeatures: string[];

	@Input() set context(
		ctx: CTAToggleButtonContext<CTAToggleButtonLayoutContext>
	) {
		this.id = this.id || ctx.id;
		this.tags = this.tags || ctx.tags;
		this.layoutContext = this.layoutContext || ctx.layoutContext;

		console.log("tags : ", this.tags);
	}

	@Output() clicked = new EventEmitter<string | number>();

	@ViewChild("componentContainer", { static: true, read: ViewContainerRef })
	componentContainer: ViewContainerRef;

	_component: ComponentRef<CTAButtonLayout>;

	constructor(
		private __resolver: ComponentFactoryResolver,
		@Optional() private __ctaButtonGroup: CtaToggleButtonGroupComponent
	) {}

	ngOnInit() {
		if (this.layoutContext && this.layoutContext.type) {
			const componentClass = components[this.layoutContext.type];
			if (componentClass) {
				const factory = this.__resolver.resolveComponentFactory<
					CTAButtonLayout
				>(componentClass);
				this._component = this.componentContainer.createComponent(
					factory
				);
				this._component.instance.layoutContext = this.layoutContext;
			}
		}

		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.addButton(this);
		}

		console.log("activating button init before activate: ", this.id);
		if (this.__selected) {
			console.log("activating button init within activate: ", this.id);
			this._clicked(true);
		}
	}

	ngOnDestroy() {
		if (this.__ctaButtonGroup) {
		}
	}

	_clicked(preserveSelection: boolean) {
		if (preserveSelection) {
			this.clicked.emit(this.id);
		} else {
			if (
				this.__ctaButtonGroup &&
				this.__ctaButtonGroup.__activeButtonId === this.id
			) {
				this.clicked.emit(null);
			} else {
				this.clicked.emit(this.id);
			}
		}
	}
}
